import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppStore } from '@app/stores/appStore';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate {
    private previousUrl: string = '/';
    private appStore = inject(AppStore);

    constructor(
        private router: Router
    ) {
        // Store the current URL before maintenance redirects
        this.router.events.subscribe(event => {
            if (
                event.constructor.name === 'NavigationEnd' &&
                !this.appStore.maintenanceMode()
            ) {
                if (!this.router.url.includes('/maintenance')) {
                    this.previousUrl = this.router.url;
                }
            }
        });
    }

    canActivate(): boolean {
        if (this.appStore.maintenanceMode()) {
            this.router.navigate(['/maintenance']);
            return false;
        }
        return true;
    }
}
